//Imports node_modules
import React, { useState, useContext, useRef, useEffect } from "react"
import {  useLocation } from 'react-router-dom';


//Imports Css
import './SearchBar.css'

//Imports Components

//Import Data
import { globalFunctions } from '../../../data/GlobalFunctions'

//Botão que procede para a operação seguinte
const SearchBar = (params) => {

    //--- Variaveis

    //Variaveis locais
    const [inputText, setInputText] = useState(params.valor);
    const descRef = useRef();
    const location = useLocation();
    const [isLoaded, setIsLoaded] = useState(false);

    const {
        advancedClick,
    } = useContext(globalFunctions);
    function handleKeyDown(e) {

        if (e.keyCode === 13) {

            switch (params.pesqType) {
                case 'product':
                    break;
                case 'productList':
                    descRef.current.blur();
                    params.currentEnter();
                    break;
                default:
                    break;
            }
        }
    }

    let inputHandler = (e) => {
        switch (params.pesqType) {
            case 'productList':
                break;
            default:
                break;
        }


        //convert input text to lower case
        var lowerCase = e.target.value.toLowerCase();

        //O leitor de barras não consegue ler _ e sibstitui por ?, isto faz reverse 
        let result = lowerCase.replace("?", "_");

        result = result.replace("#", "");
        result = result.replace("+", "");
        result = result.replace("&", "");

        setInputText(result);
        params.currentPesquisa(result);
    };

    function clearText(){
        params.currentPesquisa('');
    }

    function noKeyboardOnSearch() {
        try {
            var yourInput = document.getElementById("search");
            yourInput.readOnly = true;
            yourInput.focus();

            setTimeout(function () {
                document.getElementById("search").readOnly = false;
            }, 250);
        } catch (e) {
        }
    }

    useEffect(() => {
        setIsLoaded(true);
    }, [location]);

    useEffect(() => {
        if (isLoaded) {
            noKeyboardOnSearch()
        }
        // eslint-disable-next-line
    }, [isLoaded]);

    //--- Fim variaveis 

    return (
        <div className="search-bar">
            <input
                ref={descRef}
                onChange={inputHandler}
                onKeyDown={handleKeyDown}
                value={params.valor}
                autoComplete="off"
                placeholder="Insira o valor a procurar.."
                autoFocus={false}
                type="text"
                id="search"
                name="search"
                readOnly={params.readonly ? params.readonly : false}>
            </input>

            {params.cleanBtn? 
            
            <button
                id="MeuID"
                onClick={e => clearText()}
                onTouchStart={e => clearText()}
                onTouchEnd={e => clearText()}
                onMouseDown={e => clearText()}
                onMouseUp={e => clearText()}
            >
                <span className="fa fa-eraser" style={{ padding: '0px', fontSize: '1.1em', marginRight: '4px', }}></span>
                Limpar
            </button>
            
            :
            
            <button
                id="MeuID"
                className={params.searchBtn ? '' : 'hidden'}
                onClick={e => advancedClick(e, params.click)}
                onTouchStart={e => advancedClick(e, params.click)}
                onTouchEnd={e => advancedClick(e, params.click)}
                onMouseDown={e => advancedClick(e, params.click)}
                onMouseUp={e => advancedClick(e, params.click)}
            >
                <span className="fa fa-search" style={{ padding: '0px', fontSize: '1.1em', marginRight: '4px', }}></span>
                Pesquisar
            </button>}

            
        </div>
    )
}

export default SearchBar